import React, { Component } from 'react';
import { globalConstants } from "../../constants/globalConstants";
import UtilService from "../../services/util.service";
import globalStoreService from '../../services/global-store.service';
import BotType from '../../enums/BotType';

//import '.././App.css';

const retryMessageComponent = () => {
    return (
        <div style={{ paddingTop: '5px', paddingBottom: '5px' }}>
            <span className={(globalStoreService.get("currentBotType") === BotType.PAYMENTS_BANK) ? "arya new paymentsbank" : "arya new"} >
                {/* <img src="assets/images/arya.png" /> */}
            </span>

            <ul className="bubbles relate">
                <div>
                    <li>
                        <p>Ooops.. something went wrong!</p>
                        <span className="time">{UtilService.getCurrentTime().time_in_format}</span>
                    </li>

                </div>
            </ul>

        </div>

    )
}

export default retryMessageComponent



// WEBPACK FOOTER //
// ./src/components/message-components/retry_message.component.js